export default __webpack_public_path__ + "static/media/Firebird-Behavioral-Intervention-Meeting-Policy.faff4253.pdf";